import { apiGet, apiPost, apiPut, apiDelete, apiPatch, apiGetText } from '../services/apiClient';
import { getLocalItem, getSessionItem } from '../utils/safeStorage';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const ADMIN_ACCESS_KEY = 'adminAccessToken';

const authHeader = () => {
  const token = getSessionItem(ADMIN_ACCESS_KEY) || getLocalItem(ADMIN_ACCESS_KEY) || '';
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadAdminImage = async (file) => {
  const form = new FormData();
  form.append('image', file);
  const res = await fetch(`${API_BASE}/api/admin/upload`, {
    method: 'POST',
    headers: authHeader(),
    body: form,
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Upload failed');
  return res.json();
};

export const uploadAdminImages = async (files) => {
  const form = new FormData();
  Array.from(files || []).forEach((file) => form.append('images', file));
  const res = await fetch(`${API_BASE}/api/admin/upload/multi`, {
    method: 'POST',
    headers: authHeader(),
    body: form,
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Upload failed');
  return res.json();
};

export const listPackages = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  });
  return apiGet(`/api/admin/packages${qs.toString() ? `?${qs}` : ''}`);
};

export const getPackage = (id) => apiGet(`/api/admin/packages/${id}`);
export const createPackage = (payload) => apiPost('/api/admin/packages', payload);
export const updatePackage = (id, payload) => apiPut(`/api/admin/packages/${id}`, payload);
export const updatePackageStatus = (id, payload) => apiPatch(`/api/admin/packages/${id}/status`, payload);
export const bulkUpdatePackages = (payload) => apiPatch('/api/admin/packages/bulk', payload);
export const addPackageImages = (id, payload) => apiPost(`/api/admin/packages/${id}/images`, payload);
export const deletePackageImage = (id, imageId) => apiDelete(`/api/admin/packages/${id}/images/${imageId}`);
export const updatePackageItinerary = (id, payload) =>
  apiPut(`/api/admin/packages/${id}/itinerary`, payload);
export const deletePackage = (id) => apiDelete(`/api/admin/packages/${id}`);

export const listDestinations = () => apiGet('/api/admin/package-destinations');
export const createDestination = (payload) => apiPost('/api/admin/package-destinations', payload);
export const updateDestination = (id, payload) => apiPut(`/api/admin/package-destinations/${id}`, payload);
export const deleteDestination = (id) => apiDelete(`/api/admin/package-destinations/${id}`);

export const listThemes = () => apiGet('/api/admin/package-themes');
export const createTheme = (payload) => apiPost('/api/admin/package-themes', payload);
export const updateTheme = (id, payload) => apiPut(`/api/admin/package-themes/${id}`, payload);
export const deleteTheme = (id) => apiDelete(`/api/admin/package-themes/${id}`);

export const listOffers = () => apiGet('/api/admin/offers');
export const createOffer = (payload) => apiPost('/api/admin/offers', payload);
export const updateOffer = (id, payload) => apiPut(`/api/admin/offers/${id}`, payload);
export const deleteOffer = (id) => apiDelete(`/api/admin/offers/${id}`);

export const listTestimonials = () => apiGet('/api/admin/testimonials');
export const createTestimonial = (payload) => apiPost('/api/admin/testimonials', payload);
export const updateTestimonial = (id, payload) => apiPut(`/api/admin/testimonials/${id}`, payload);
export const deleteTestimonial = (id) => apiDelete(`/api/admin/testimonials/${id}`);

export const listArticles = () => apiGet('/api/admin/articles');
export const createArticle = (payload) => apiPost('/api/admin/articles', payload);
export const updateArticle = (id, payload) => apiPut(`/api/admin/articles/${id}`, payload);
export const deleteArticle = (id) => apiDelete(`/api/admin/articles/${id}`);

export const getLandingConfig = () => apiGet('/api/admin/landing/packages');
export const updateLandingConfig = (payload) => apiPut('/api/admin/landing/packages', payload);
export const getPackagePageSettings = () => apiGet('/api/admin/package-page-settings');
export const updatePackagePageSettings = (payload) => apiPut('/api/admin/package-page-settings', payload);

export const getPackagesListingConfig = () => apiGet('/api/admin/packages-listing');
export const updatePackagesListingConfig = (payload) => apiPut('/api/admin/packages-listing', payload);

export const listCustomRequests = () => apiGet('/api/admin/custom-tour-requests');
export const updateCustomRequest = (id, payload) => apiPatch(`/api/admin/custom-tour-requests/${id}`, payload);

export const listPackageEnquiries = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  });
  return apiGet(`/api/admin/package-enquiries${qs.toString() ? `?${qs}` : ''}`);
};
export const getPackageEnquiry = (id) => apiGet(`/api/admin/package-enquiries/${id}`);
export const updatePackageEnquiry = (id, payload) => apiPatch(`/api/admin/package-enquiries/${id}`, payload);
export const deletePackageEnquiry = (id) => apiDelete(`/api/admin/enquiries/${id}`);
export const exportPackageEnquiriesCsv = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  });
  return apiGetText(`/api/admin/package-enquiries/export${qs.toString() ? `?${qs}` : ''}`);
};


